// @ref: https://toddmotto.com/ditch-the-array-foreach-call-nodelist-hack/

// forEach method
var forEach = function (array, callback, scope) {
    for (var i = 0; i < array.length; i++) {
        callback.call(scope, i, array[i]); // passes back stuff we need
    }
};

// Usage:
// var myNodeList = document.querySelectorAll('li');
// forEach(myNodeList, function (index, value) {
//     console.log(index, value); // passes index + value back!
// });

var utils = {
    forEach: forEach
};

module.exports = utils;
